import { TThunkAction } from '../../types/redux';
import { notify } from '../../actions/notifications';
import { ENotificationStyle } from '../../types/notifications';
import { fetchShareFolderOffers, IShareFolderOffersRequest } from '../../repositories/favorites/v1/share-folder-offers';

export const getTextForShareFolder = (folderId: number): TThunkAction<Promise<string>> => async (
  dispatch,
  getState,
  { httpApi, logger },
) => {
  const showError = () => dispatch(notify('Не удалось поделиться подборкой', ENotificationStyle.Error));

  try {
    const parameters: IShareFolderOffersRequest = { folderId };
    const { statusCode, response } = await fetchShareFolderOffers({ httpApi, parameters });

    if (statusCode === 200) {
      return response.sharingText;
    }

    if (statusCode === 400) {
      showError();
      logger.warning(response.message);
    }
  } catch (e) {
    showError();
    logger.error(e, {
      description: 'Fail to share folders offers',
    });
  }

  return false;
};
